{
  "notifications": {
    "eyebrow": "アカウント",
    "title": "通知",
    "subtitle": "入札、落札、発送についてBidNovaからの連絡方法を管理します。",
    "notFound": "ページが見つかりません。",
    "pageTitle": "通知設定 — BidNova Auctions"
  },
  "bell": {
    "ariaUnread": "通知、未読{count}件",
    "ariaNoUnread": "通知",
    "title": "通知",
    "unreadCount": "未読{count}件",
    "allCaughtUp": "すべて確認済みです",
    "markAllRead": "すべて既読にする",
    "empty": "通知はまだありません。",
    "settingsLink": "通知設定",
    "defaultTitle": "通知",
    "timeJustNow": "たった今",
    "timeMinutes": "{count}分前",
    "timeHours": "{count}時間前",
    "timeDays": "{count}日前",
    "timeWeeks": "{count}週間前",
    "toastMarkOneError": "既読にできませんでした",
    "toastMarkAllError": "すべてを既読にできませんでした",
    "toastMarkAllSuccess": "すべて確認済みです"
  },
  "prefs": {
    "eyebrow": "通知",
    "subtitle": "BidNovaからの連絡方法を選択してください。",
    "enableGlobalPush": "ブラウザプッシュ通知を全体で有効にする",
    "addDevice": "この端末を追加",
    "sendTest": "テスト送信",
    "categoriesHeading": "カテゴリー",
    "eventsHeading": "イベント",
    "colInApp": "アプリ内",
    "colEmail": "メール",
    "colPush": "プッシュ",
    "devicesHeading": "端末",
    "noDevices": "登録されたプッシュ端末はまだありません。",
    "removeDevice": "端末を削除",
    "failures": "{count}回失敗",
    "toastPushNotConfigured": "プッシュ通知はまだ設定されていません。",
    "toastPushDenied": "プッシュ通知の許可が拒否されました。",
    "toastPushEnabled": "この端末でプッシュ通知が有効になりました",
    "toastTestSent": "テスト通知を送信しました（{count}チャネル）",
    "category": {
      "pushMaster": "プッシュ通知マスタースイッチ",
      "auctionOutbid": "他の入札者に上回られた",
      "auctionWon": "オークション落札",
      "auctionLost": "オークション落選",
      "endingSoon": "まもなく終了",
      "paymentReceived": "支払い受領",
      "paymentReleased": "支払い解放",
      "sellerMessage": "出品者からのメッセージ",
      "buyerMessage": "購入者からのメッセージ",
      "systemUpdates": "システム更新情報",
      "securityAlerts": "セキュリティ警告",
      "weeklySummary": "週間サマリー",
      "marketing": "マーケティング（オプトイン）"
    },
    "event": {
      "endingSoon": "オークション終了間近",
      "priceDrop": "価格変動／即決価格の変更",
      "wantMatch": "ウォントリストの一致が見つかりました",
      "outbid": "他の入札者に上回られました",
      "auctionWon": "オークション落札",
      "auctionLost": "オークション落選",
      "reserveMet": "リザーブ価格達成",
      "paymentRequired": "支払いが必要です",
      "paymentReceived": "支払い受領",
      "dispatchRequired": "出品者の発送が必要です",
      "itemDispatched": "商品発送済み",
      "trackingUpdate": "Royal Mail 追跡情報更新",
      "deliveryConfirm": "配達確認",
      "payoutReleased": "売上金の入金",
      "disputeUpdate": "異議申し立ての更新",
      "promotionActivated": "注目出品プロモーションが有効化されました",
      "reservationExpiring": "即決価格の予約がまもなく期限切れになります",
      "watchlistNewBid": "ウォッチリストのオークションに新しい入札",
      "auctionBelowReserve": "オークションはリザーブ価格未達で終了しました",
      "refundCompleted": "返金完了",
      "listingApproved": "出品が承認されました",
      "listingRejected": "出品に修正が必要です"
    }
  },
  "watchlist": {
    "pageTitle": "ウォッチリスト",
    "eyebrow": "購入者",
    "title": "ウォッチリスト",
    "subtitle": "追跡中のカードです。終了前に入札しましょう。",
    "browseAuctions": "オークションを見る",
    "errorDescription": "ウォッチリストを読み込めませんでした。",
    "emptyTitle": "ウォッチリストは空です",
    "emptyDescription": "オークションを閲覧して、ハートマークでお気に入りを保存しましょう。",
    "discoverCards": "カードを探す"
  },
  "wantList": {
    "pageTitle": "ウォントリスト — BidNova Auctions",
    "pageDescription": "探しているカードを追跡し、BidNovaの進行中オークションと照合します。",
    "title": "ウォントリスト",
    "subtitle": "探しているカードを追跡すると、一致する進行中のオークションをお知らせします。",
    "refreshMatches": "一致結果を更新",
    "cardName": "カード名 *",
    "cardNamePlaceholder": "Charizard",
    "set": "セット",
    "setPlaceholder": "Base Set",
    "maxPrice": "上限価格（£）",
    "addButton": "ウォントリストに追加",
    "yourWantList": "ウォントリスト",
    "anySet": "セット指定なし",
    "active": "有効",
    "paused": "一時停止中",
    "pause": "一時停止",
    "resume": "再開",
    "noItemsYet": "まだ項目がありません。",
    "matches": "一致結果",
    "matched": "{date}に一致",
    "noMatchesYet": "まだ一致結果はありません — 「一致結果を更新」をクリックしてください。",
    "toastAdded": "ウォントリストに追加しました",
    "toastMatchesFound": "{count}件の一致が見つかりました"
  },
  "myBids": {
    "pageTitle": "自分の入札",
    "eyebrow": "購入者",
    "title": "自分の入札",
    "errorDescription": "入札履歴を読み込めませんでした。",
    "emptyTitle": "まだ入札していません。",
    "emptyDescription": "お気に入りのカードを見つけて、最初の入札をしましょう。",
    "browseAuctions": "オークションを見る",
    "yourBid": "あなたの入札額：{amount}",
    "won": "落札しました 🎉",
    "ended": "終了",
    "winning": "最高額入札中",
    "outbid": "上回られました"
  },
  "myAuctions": {
    "pageTitle": "自分の出品",
    "eyebrow": "出品者",
    "title": "自分の出品",
    "subtitle": "進行中の出品を管理し、過去の販売実績を確認しましょう。",
    "listACard": "カードを出品",
    "errorDescription": "出品情報を読み込めませんでした。",
    "activeHeading": "進行中（{count}）",
    "endedHeading": "終了済み（{count}）",
    "noActiveListings": "進行中の出品はありません。作成して始めましょう。",
    "nothingEndedYet": "終了した出品はまだありません。",
    "bidsCount": "{count}件の入札",
    "endsOn": "終了：{date}",
    "featuredUntil": "{date}まで注目出品",
    "extend": "延長",
    "promote": "注目出品にする"
  },
  "collection": {
    "pageTitle": "コレクション · BidNova",
    "pageDescription": "所有するカード、取得コスト、推定コレクション価値を追跡します。",
    "eyebrow": "コレクション管理",
    "title": "コレクション",
    "subtitle": "出品中のカードとは別に、所有カードを追跡できます。推定価値は実際の市場データに基づき、データがない場合は取得コストのみを表示します。",
    "collectionsHeading": "コレクション",
    "allItems": "すべてのアイテム",
    "newCollectionPlaceholder": "新しいコレクション",
    "noCardsYet": "まだカードがありません。コレクションを作成して最初のカードを追加しましょう。",
    "untitledCard": "名称未設定のカード",
    "quantityShort": "x{count}",
    "acquisitionShort": "取得 {amount}",
    "unarchive": "アーカイブ解除",
    "archive": "アーカイブ",
    "noValuationsYet": "評価はまだありません。カードの価格提案を実行すると推定価値が表示されます。",
    "cardsLabel": "カード枚数",
    "acquisitionCostLabel": "取得コスト",
    "estimatedValueLabel": "推定価値",
    "realisedProfitLabel": "実現利益",
    "addACard": "カードを追加",
    "cardNameLabel": "カード名",
    "setLabel": "セット",
    "quantityLabel": "数量",
    "acquisitionCostPoundLabel": "取得コスト（£）",
    "graded": "鑑定済み",
    "addCardButton": "カードを追加"
  }
}
